import { defineType } from "sanity";
import { multilingualArrayBlockContent } from "../base";

export default defineType({
  name: "asCardBlockContent",
  title: "Render as Card",
  description: "Control how this page will display in sliders etc.",
  options: {
    collapsible: true,
    collapsed: true
  },
  type: "object",
  fields: [
    {
      title: "Card Image",
      name: "image",
      type: "imageWithAlt"
    },
    {
      name: "title",
      title: "Card Title",
      description:
        "When set, the card will use this title instead of the main page title.",
      type: multilingualArrayBlockContent.name
    },
    {
      name: "mainAdvantage",
      title: "Main Advantage",
      type: multilingualArrayBlockContent.name
    },
    {
      name: "description",
      title: "Description on Card",
      description: "Content to appear in the card, below the title",
      type: multilingualArrayBlockContent.name
    }
  ]
});
